import { HelpOutline } from "@mui/icons-material";
import {
	Box,
	IconButton,
	Popover,
	Stack,
	Typography,
	useTheme,
} from "@mui/material";
import { useRef, useState } from "react";

import {
	CommissionDistributionResource,
	useCommissionDistributionResource,
} from "CommissionDistribution/Translations/CommissionDistributionResource";

export const CommissionDistributionTypeTooltip = () => {
	const { t } = useCommissionDistributionResource();
	const R = CommissionDistributionResource;
	const theme = useTheme();
	const buttonRef = useRef<HTMLButtonElement | null>(null);
	const [open, setOpen] = useState(false);

	const items = [
		{
			name: t(R.Types.Realizator.Name),
			desc: t(R.Types.Realizator.Description),
			emphasis: true,
		},
		{
			name: t(R.Types.ContractTipster.Name),
			desc: t(R.Types.ContractTipster.Description),
		},
		{
			name: t(R.Types.ClientTipster.Name),
			desc: t(R.Types.ClientTipster.Description),
		},
		{
			name: t(R.Types.InvitedSpecialist.Name),
			desc: t(R.Types.InvitedSpecialist.Description),
		},
	];

	return (
		<>
			<IconButton
				ref={buttonRef}
				size="small"
				onClick={() => setOpen((v) => !v)}
				aria-label={t(R.Types.Header)}
			>
				<HelpOutline fontSize="inherit" />
			</IconButton>
			<Popover
				open={open}
				anchorEl={buttonRef.current}
				onClose={() => setOpen(false)}
				anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
				slotProps={{
					paper: { sx: { maxWidth: 320, p: 0 } },
				}}
			>
				<Box
					sx={{
						px: 1.5,
						py: 1,
						bgcolor: theme.palette.grey[100],
						borderBottom: `1px solid ${theme.palette.divider}`,
					}}
				>
					<Typography
						variant="caption"
						sx={{
							textTransform: "uppercase",
							fontWeight: 700,
							color: "text.secondary",
						}}
					>
						{t(R.Types.Header)}
					</Typography>
				</Box>
				<Stack
					divider={
						<Box sx={{ borderTop: `1px solid ${theme.palette.divider}` }} />
					}
				>
					{items.map((item) => (
						<Box key={item.name} sx={{ px: 1.5, py: 1 }}>
							<Typography
								variant="body2"
								sx={{
									fontWeight: 700,
									color: item.emphasis ? theme.palette.primary.main : undefined,
								}}
							>
								{item.name}
							</Typography>
							<Typography variant="caption" color="text.secondary">
								{item.desc}
							</Typography>
						</Box>
					))}
				</Stack>
			</Popover>
		</>
	);
};
